import { Component, OnInit, ViewChild, NgZone, Inject, HostListener } from '@angular/core';
import {
  BankNotificationPayMetadata,
  CustomerNotification,
  CustomerNotificationCounts} from '../../../services/customer-notification.model';
import { CustomerNotificationService } from '../../../services/customer-notification.service';
import { CustomerNotificationCategory, CustomerNotificationType, EmployeeAlertDetailsAccountType, PayrollType }
from '../../../shared/enums/smarthub-enums';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { SettingsService } from '../../../shared/services/settings/settings.service';
import { Observable ,  Subject } from 'rxjs';
import { AlertsFilters } from './alerts-filters.model';
import { PayGroupService } from '../../../services/paygroup.service';
import { PayGroup } from '../../../shared/models/pay-group.model';
import { filter, map, takeUntil } from 'rxjs/operators';
import * as _ from 'lodash';
import { sortBy } from 'lodash';
import * as moment from 'moment-timezone';
import { Moment } from 'moment';
import { PayrollCycleType, PayrollTypeInfo, PayrollTypeService } from '../../../services/payroll-types.service';
import { PayService } from '../../../services/pay.service';
import { AlertNotificationDetails, ExportableAlertDetails } from '../../../services/alert-notification-details.model';
import { HttpErrorResponse } from '@angular/common/http';
import { BaseObserver } from '../../../shared/baseobserver';
import { CompanyService } from '../../../services/company.service';
import { CompanyBasicInfo } from '../../../services/company.model';
import { TranslateService } from '@ngx-translate/core';
import { UserMessage, UserNotification, UserNotificationCommand } from '../../../shared/components/notification-bar/notification-bar.model';
import { FeatureToggleService } from '../../../shared/services/feature-toggle/feature-toggle.service';
import { ES5ZoneAwareRouter } from '../../../elements-routing/es5ZoneAwareRouter';
import { FileExportService } from '../../../shared/services/export-file/export-file.service';
import { UltiCurrencyPipe } from '../../../shared/pipes/ulticurrency.pipe';
import { EnumTranslatePipe } from '../../../shared/pipes/enumtranslate.pipe';
import { EntitlementsService } from '../../../entitlements/entitlements.service';
import { HeaderService } from '../../header/header.service';

class CustomerNotificationGroup {
  readonly groupKey: CustomerNotificationGroupKey;
  readonly notifications: CustomerNotification[];
  expanded = true;

  get hasData() {
    return this.notifications.length > 0;
  }

  constructor(key: CustomerNotificationGroupKey, notifications: CustomerNotification[]) {
    this.groupKey = key;
    this.notifications = notifications;
  }
}

class CustomerNotificationGroupKey {
  readonly payUtcDate: Moment;
  readonly payGroup: string;
  readonly payrollType: PayrollType;
  private readonly value: string;

  constructor(notification: CustomerNotification) {
    this.payUtcDate = moment.utc(notification.payUtcDate);
    this.payGroup = notification.payGroup;
    this.payrollType = notification.payrollType;
    this.value = this.payUtcDate.format('YYYYMMDD') + this.payGroup + this.payrollType;
  }

  valueOf() {
    return this.value;
  }
}

class OldExportedAlertItem {
  static headers = {
    companyName: 'Company Name',
    payGroup: 'Pay Group',
    name: 'Employee Name',
    employeeId: 'Employee ID',
    exceptionDate: 'Exception Entry Date',
    payDate: 'Pay Date',
    itemAmount: 'Item Amount',
    accountNumber: 'Account Number',
    routingNumber: 'Routing Number',
    alertType: 'Alert Type',
    bankCode: 'Bank Code',
    bankDescription: 'Bank Description',
    correctedData: 'Corrected Data',
    companyId: 'Company Id',
    companyDescription: 'Company Description',
    dfiAccountNum: 'DFI Account #',
    originalEntryTraceNum: 'Original Entry Trace #',
    effectiveEntryDate: 'Effective Entry Date'
  };

  static footer = {
    name: '* Printed on ' + moment().format('MM/DD/YYYY')
  };

  constructor(
    public companyName: string,
    public payGroup: string,
    public name: string,
    public employeeId: string,
    public exceptionDate: string,
    public payDate: string,
    public itemAmount: string,
    public accountNumber: string,
    public routingNumber: string,
    public alertType: string,
    public bankCode: string,
    public bankDescription: string,
    public correctedData: string,
    public companyId: string,
    public companyDescription: string,
    public dfiAccountNum: string,
    public originalEntryTraceNum: string,
    public effectiveEntryDate: string) {}
}

class ExportedAlertItem {

  static headers = {
    companyName: 'Company Name',
    payGroup: 'Pay Group',
    name: 'Employee Name',
    employeeId: 'Employee ID',
    exceptionDate: 'Exception Entry Date',
    payDate: 'Pay Date',
    itemAmount: 'Item Amount',
    accountNumber: 'Original Account #',
    routingNumber: 'Original Routing #',
    accountType: 'Original Account Type',
    alertType: 'Alert Type',
    bankCode: 'Bank Code',
    bankDescription: 'Bank Error',
    bankProvidedAccountNumber: 'Bank Provided Account #',
    bankProvidedRoutingNumber: 'Bank Provided Routing #',
    bankProvidedAccountType: 'Bank Provided Account Type',
    companyId: 'Company ID',
    companyDescription: 'Company Description',
    originalEntryTraceNum: 'Original Entry Trace #',
    effectiveEntryDate: 'Effective Entry Date'
  };

  static footer = {
    name: '* Printed on ' + moment().format('MM/DD/YYYY')
  };

  constructor(
    public companyName: string,
    public payGroup: string,
    public name: string,
    public employeeId: string,
    public exceptionDate: string,
    public payDate: string,
    public itemAmount: string,
    public accountNumber: string,
    public routingNumber: string,
    public accountType: string,
    public alertType: string,
    public bankCode: string,
    public bankDescription: string,
    public bankProvidedAccountNumber: string,
    public bankProvidedRoutingNumber: string,
    public bankProvidedAccountType: string,
    public companyId: string,
    public companyDescription: string,
    public originalEntryTraceNum: string,
    public effectiveEntryDate: string) {}
}


@Component({
  selector: 'ssg-alerts-details',
  templateUrl: './alerts-details.component.html',
  styleUrls: ['./alerts-details.component.less']
})

export class AlertsDetailsComponent extends BaseObserver implements OnInit {
  @ViewChild('bankNotificationPayHeader', { static: true }) bankNotificationPayHeaderTemplate;
  @ViewChild('bankNotificationPayItem', { static: true }) bankNotificationPayItemTemplate;
  @ViewChild('bankNotificationPayDetails', { static: true }) bankNotificationPayDetailsTemplate;
  @ViewChild('bankNotificationPayDetailsNew', { static: true }) bankNotificationPayDetailsNewTemplate;
  @ViewChild('unknownHeader', { static: false }) unknownHeaderTemplate;
  @ViewChild('unknownItem', { static: false }) unknownItemTemplate;

  private countsByCategory: CustomerNotificationCounts[] = [];
  private _statusNotification: UserNotification = null;
  private _selectedTab: CustomerNotificationCategory;
  readonly minDate = '0001-01-01T00:00:00';

  notificationGroups: CustomerNotificationGroup[] = [];
  editFilters: AlertsFilters;
  allPayGroups: PayGroup[] = [];
  allPayrollTypes: PayrollTypeInfo[] = [];
  allCompanies: CompanyBasicInfo[] = [];
  userMessages = {
    noNotifications : new UserMessage({message: 'ALERTS.NO_CURRENT_NOTIFICATIONS', severity: 'information'}),
    noNotificationsFiltered : new UserMessage({message: 'ALERTS.NO_CURRENT_NOTIFICATIONS_FILTERED', severity: 'information'}),
    filterNotifications : new UserMessage({
      message: 'ALERTS.FILTER_ALERTS_INFO',
      severity: 'information',
      persistToStorage: true,
      distinct: true
    }),
    noTabs : new UserMessage({ message: '', severity: 'information', persistToStorage: true }),
    notificationCannotBeChanged: new UserMessage({ message: 'ALERTS.BAD_REQUEST', severity: 'warning' }),
    notAuthorized: new UserMessage({ message: 'ALERTS.NOT_AUTHORIZED', severity: 'warning' }),
    conflict: new UserMessage({ message: 'ALERTS.CONFLICT', severity: 'warning' })
  };

  notificationSubject: Subject<UserNotificationCommand> = new Subject<UserNotificationCommand>();
  navOut: () => Promise<boolean>;

  @HostListener('window:popstate', ['$event'])
  onPopState(ev: PopStateEvent) {
    this.navOut();
    ev.preventDefault();
  }

  get tabCounts(): CustomerNotificationCounts[] {
    if (!this.countsByCategory) {
 return null;
}
    const tabCounts = this.enableFifteenDayAlertsAndNotifications
      ? this.countsByCategory.filter(x => x.category !== CustomerNotificationCategory.Unknown)
      : this.countsByCategory.filter(x => x.total > 0 && x.category !== CustomerNotificationCategory.Unknown);
    if (!this.notificationGroups) {
 return tabCounts;
}
    const notifsByCategory = this.notificationsByCategory;
    return tabCounts
      .map(counts => {
        const filteredNotifications: CustomerNotification[] = notifsByCategory[counts.category];
        counts.filtered = filteredNotifications ? filteredNotifications.length : 0;
        return counts;
      });
  }

  private _addStatusNotification(notif: string, params: any = null) {
    this._statusNotification = new UserNotification(notif, params);
    this.notificationSubject.next(new UserNotificationCommand('add', this._statusNotification));
  }

  private _clearStatusNotification(): void {
    this.notificationSubject.next(new UserNotificationCommand('clearKey', this._statusNotification));
    this._statusNotification = null;
  }

  get selectedTab(): CustomerNotificationCategory {
      return this._selectedTab;
  }
  set selectedTab(category: CustomerNotificationCategory) {
    this._selectedTab = category;
    this.router.navigate([{outlets: { eepay: ['alertsdetails', { category: this._selectedTab }]}}]);
  }

  get notificationsByCategory(): { [key: number]: CustomerNotification[] } {
    return this.notificationGroups.reduce(
      (nByC, g) => g.notifications.reduce(
        (dict, n) => {
          const ns: CustomerNotification[] = dict[n.category];
          dict[n.category] = ns ? ns.concat(n) : [ n ];
          return dict;
        }, nByC
      ) , {} as { [key: number]: CustomerNotification[] }
    );
  }

  get enableFifteenDayAlertsAndNotifications(): boolean {
    return this.configService.isFeatureEnabled('enableFifteenDayAlertsAndNotifications');
  }

  get enableAlertDetailsNachaAuditInfo(): boolean {
    return this.configService.isFeatureEnabled('enableAlertDetailsNachaAuditInfo');
  }

  get enableEEPayPSGAlertUpdates(): boolean {
    return this.configService.isFeatureEnabled('eEPayPSGAlertUpdates');
  }

  constructor(private readonly customerNotificationService: CustomerNotificationService,
    private readonly payGroupService: PayGroupService,
    private readonly payrollTypeService: PayrollTypeService,
    private readonly payService: PayService,
    private readonly companyService: CompanyService,
    private readonly settings: SettingsService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly translateService: TranslateService,
    private readonly router: ES5ZoneAwareRouter,
    private readonly configService: FeatureToggleService,
    private readonly fileExportService: FileExportService,
    private readonly currencyPipe: UltiCurrencyPipe,
    private readonly enumPipe: EnumTranslatePipe,
    private readonly entitlementsService: EntitlementsService,
    private readonly zone: NgZone,
    private readonly headerService: HeaderService,
    ) {
      super();
      this.editFilters = AlertsFilters.default;
      this.headerService.navEvents.pipe(
        takeUntil(this.destroy$)
      ).subscribe((prom) => {
        this.navOut = prom;
      });
  }

  ngOnInit() {
    this._applyUrlParams(this.activatedRoute.paramMap);
    this._initFilters();
  }

  tabSelected(event, tab: CustomerNotificationCategory) {
    this.selectedTab = tab;
  }

  public async loadTab(tab: CustomerNotificationCategory) {
    this.countsByCategory = await this._loadCounts();
    if (!this.countsByCategory || this.countsByCategory.length < 1) {
      this._addStatusNotification('noTabs');
      return;
    }
    const counts = this.countsByCategory.find(c => c.category === tab);
    if (!counts || counts.total < 1) {
      this._clearNotifications();
      this._addStatusNotification('noNotifications');
      return;
    }
    this.notificationSubject.next(new UserNotificationCommand('add', new UserNotification('filterNotifications')));
    this._loadNotifications(tab);
  }

  setAcknowledged(id: string, ack: boolean) {
    this.customerNotificationService.updateAcknowledged(this.settings.tenantId, id, ack)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (updated: CustomerNotification) => {
          if (updated) {
            this._refreshCount(updated.category);
            this._updateNotification(id, updated);
          }
        },
        (error: HttpErrorResponse) => {
          switch (error.status) {
            case 404:
              this._addStatusNotification('notAuthorized');
              break;
            case 400:
              this._addStatusNotification('notificationCannotBeChanged');
              break;
            case 409:
              this._addStatusNotification('conflict');
              break;
            default:
              this._handleError(error);
          }
        });
  }

  private _updateNotification(id: string, updated: CustomerNotification): void {
    const groupKeyValue = new CustomerNotificationGroupKey(updated).valueOf();
    const groupIndex: number = this.notificationGroups.findIndex(g => g.groupKey.valueOf() === groupKeyValue);
    if (groupIndex === -1) {
 return;
}
    const notificationIndex: number = this.notificationGroups[groupIndex].notifications.findIndex(n => n.id === id);
    if (notificationIndex === -1) {
 return;
}
    const origRecord = this.notificationGroups[groupIndex].notifications[notificationIndex];
    origRecord.acknowledged = updated.acknowledged;
    origRecord.acknowledgedUtcDateTime = updated.acknowledgedUtcDateTime;
    origRecord.acknowledgedBy = updated.acknowledgedBy;
  }

  detailsExpanded(item: CustomerNotification, expanded: boolean) {
    item.showDetails = expanded;
    if (expanded && !item.details) {
      const metadata = item.typedMetadata<BankNotificationPayMetadata>();
      let obs: Observable<AlertNotificationDetails>;
      if (this.configService.isFeatureEnabled('enablePrenoteAlertsNotifications')) {
        obs = this.customerNotificationService.getNotificationDetails(this.settings.tenantId, item.id);
      } else {
        obs = this.payService.getAlertsPayDetails(
          metadata.itemId,
          { actionId: metadata.actionId,
            isNoc: item.isNoc
          });
      }
      obs
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (details: AlertNotificationDetails) => {
            item.details = details;
          },
          (error) => this._handleError(error));
    }
  }

  private _applyUrlParams(paramMap: Observable<ParamMap>) {
    paramMap
      .pipe(takeUntil(this.destroy$))
      .subscribe(
      params => {
        // Category
        const categoryOrdinal = Number(params.get('category'));
        const category: CustomerNotificationCategory = CustomerNotificationCategory[CustomerNotificationCategory[categoryOrdinal]];
        this._selectedTab = category;
        this.zone.run(() => this.loadTab(this.selectedTab));
      }
    );
  }

  private _refreshCount(category: CustomerNotificationCategory) {
    const countsIndex = this.countsByCategory.findIndex(c => c.category === category);
    if (countsIndex < 0) {
      return;
    }
    this.countsByCategory[countsIndex].isRefreshing = true;
    this.customerNotificationService
    .getRecentCounts(this.settings.tenantId, category, this.editFilters.ackFilter)
    .pipe(takeUntil(this.destroy$))
    .subscribe(
      (counts: CustomerNotificationCounts) => {
        const updatedCounts = new CustomerNotificationCounts({
          category,
          unAcknowledged: counts.unAcknowledged,
          acknowledgedRecently: counts.acknowledgedRecently,
          isRefreshing: false });
        this.countsByCategory[countsIndex] = updatedCounts;
      },
      (error) => this._handleError(error)
    );
  }

  private _loadCounts(): Promise<CustomerNotificationCounts[]> {
    return new Promise(
      (resolve, reject) => {
        this.customerNotificationService
        .getRecentCountsAllCategories(this.settings.tenantId)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (countsData: CustomerNotificationCounts[]) => {
            const counts = countsData.map(d => new CustomerNotificationCounts({
              category: d.category,
              unAcknowledged: d.unAcknowledged,
              acknowledgedRecently: d.acknowledgedRecently,
            }));
            resolve(counts);
          },
          (error) => reject(error)
        );
      }
    );
  }

  private _loadNotifications(category: CustomerNotificationCategory) {
    this.customerNotificationService.getCustomerNotifications(
        this.settings.tenantId,
        category,
        this.editFilters.ackFilter,
        this.editFilters.payDate,
        this.editFilters.hasPayGroups ? this.editFilters.payGroups.map(p => p.name) : undefined,
        this.editFilters.hasFundTypeReturned ? this.editFilters.hasFundTypeReturned : undefined,
        this.editFilters.hasFundTypeNotReturned ? this.editFilters.hasFundTypeNotReturned : undefined,
        this.editFilters.payrollType,
        this.editFilters.hasComponentCompany ? this.editFilters.componentCompany : undefined
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (notificationsData: CustomerNotification[]) => {
          const notifications = notificationsData.map(x => new CustomerNotification(x));
          this._processNotifications(notifications);
        },
        (error) => this._handleError(error)
      );
  }

  private _processNotifications(notifications: CustomerNotification[]) {
    if (!notifications || notifications.length === 0) {
      this._clearNotifications();
      this._addStatusNotification('noNotificationsFiltered');
      return;
    }
    this._clearNotifications();
    this.notificationGroups = _(notifications)
      .sortBy(['payUtcDate', 'payGroup', 'payrollType'])
      .groupBy(notif => new CustomerNotificationGroupKey(notif).valueOf())
      .reduce(
        (groups: CustomerNotificationGroup[], g: CustomerNotification[]) => {
          groups.push(new CustomerNotificationGroup(new CustomerNotificationGroupKey(g[0]), g));
          return groups;
        },
        new Array<CustomerNotificationGroup>()
      );
  }

  get showAcknowledgeLink(): boolean {
    return this.entitlementsService.isEntitled(['AcknowledgeCustomerNotification']);
  }

  private _clearNotifications() {
    this.notificationGroups = [];
  }

  private _handleError(error) {
  }

  getTabStyleClass(tab: CustomerNotificationCategory) {
    if (tab === this.selectedTab) {
       return 'alerts-tab alerts-tab-selected';
    }
    return 'alerts-tab';
  }

  getHeaderTemplate(category: CustomerNotificationCategory) {
    switch (category) {
      case CustomerNotificationCategory.BankNotificationPay:
        return this.bankNotificationPayHeaderTemplate;
      default:
        return this.unknownHeaderTemplate;
    }
  }

  getItemTemplate(notificationType: CustomerNotificationType) {
    switch (notificationType) {
      case CustomerNotificationType.BankNotificationPayNoc:
      case CustomerNotificationType.BankNotificationPayUndoNoc:
      case CustomerNotificationType.BankNotificationPayRejection:
      case CustomerNotificationType.BankNotificationPayUndoRejection:
      case CustomerNotificationType.BankNotificationPayReturn:
      case CustomerNotificationType.BankNotificationPayUndoReturn:
        return this.bankNotificationPayItemTemplate;
      default:
        return this.unknownItemTemplate;
    }
  }

  getDetailsTemplate(notificationType: CustomerNotificationType) {
    switch (notificationType) {
      case CustomerNotificationType.BankNotificationPayNoc:
      case CustomerNotificationType.BankNotificationPayUndoNoc:
      case CustomerNotificationType.BankNotificationPayRejection:
      case CustomerNotificationType.BankNotificationPayUndoRejection:
      case CustomerNotificationType.BankNotificationPayReturn:
      case CustomerNotificationType.BankNotificationPayUndoReturn:
      default:
        if (this.enableEEPayPSGAlertUpdates) {
          return this.bankNotificationPayDetailsNewTemplate;
        }
        return this.bankNotificationPayDetailsTemplate;
    }
  }

  getRecommendedAction(notification: CustomerNotification): string {
    if (!this.configService.isFeatureEnabled('eEPayPSGAlertUpdates')) {
      switch (notification.type) {
        case CustomerNotificationType.BankNotificationPayNoc:
          return this.enableAlertDetailsNachaAuditInfo ? 'ALERTS.RECOMMENDED_ACTION_NOC' : 'ALERTS.RECOMMENDED_ACTION_NO_FUNDS_RETURNED';
        case CustomerNotificationType.BankNotificationPayRejection:
          return notification.typedMetadata<BankNotificationPayMetadata>().amount === 0
            ? 'ALERTS.RECOMMENDED_ACTION_NO_FUNDS_RETURNED'
            : 'ALERTS.RECOMMENDED_ACTION_REJ';
        case CustomerNotificationType.BankNotificationPayReturn:
          return notification.typedMetadata<BankNotificationPayMetadata>().amount === 0
            ? 'ALERTS.RECOMMENDED_ACTION_NO_FUNDS_RETURNED'
            : 'ALERTS.RECOMMENDED_ACTION_RET';
        case CustomerNotificationType.BankNotificationPayUndoNoc:
          return 'ALERTS.RECOMMENDED_ACTION_UNDO_NOC';
        case CustomerNotificationType.BankNotificationPayUndoRejection:
          return 'ALERTS.RECOMMENDED_ACTION_UNDO_REJECTION';
        case CustomerNotificationType.BankNotificationPayUndoReturn:
          return 'ALERTS.RECOMMENDED_ACTION_UNDO_RETURN';
        default:
          return '';
      }
    }

    const key = `ALERTS.RECOMMENDED_ACTION_${(notification.metadata as any).bankCode}`;
    const specificRecommendedAction = this.translateService.instant(key);
    return specificRecommendedAction !== key ? specificRecommendedAction : this.translateService.instant('ALERTS.RECOMMENDED_ACTION_OTHER');
  }

  getCategoryTooltip(category: CustomerNotificationCategory): string {
    switch (category) {
      case CustomerNotificationCategory.BankNotificationPay:
        return this.enableFifteenDayAlertsAndNotifications
          ? 'ALERTS.TOOLTIP_CATEGORY_RET_REJ_NOC2'
          : 'ALERTS.TOOLTIP_CATEGORY_RET_REJ_NOC1';
      default:
        return 'No tooltip';
    }
  }

  getGroupTooltip(category: CustomerNotificationCategory): string {
    switch (category) {
      case CustomerNotificationCategory.BankNotificationPay:
        return 'ALERTS.TOOLTIP_GROUP_RET_REJ_NOC';
      default:
        return 'No tooltip';
    }
  }

  translateBankCode(code: string): string {
    const prefix = this.enableEEPayPSGAlertUpdates ? 'BANK_NOTIFICATION_CODE_ENHANCED.' : 'BANK_NOTIFICATION_CODE.';
    const translationCode = prefix + code.toUpperCase();
    const translation =  this.translateService.instant(translationCode);
    return translation === '[' + translationCode + ']'
      ? this.translateService.instant('ALERTS.INVALID_BANK_CODE')
      : translation;
  }

  translateAccountType(accountType: EmployeeAlertDetailsAccountType): string {
    const translationCode =  this.getAccountTypeTranslationCode(accountType);
    return (translationCode) ? this.translateService.instant(translationCode) : '';
  }

  translateAccountTypeAndCode(accountType: EmployeeAlertDetailsAccountType, accountTypeCode: string): string {
    const translatedAccountType = this.translateAccountType(accountType);
    return (translatedAccountType) ? translatedAccountType + ' (' + accountTypeCode + ')' : '';
  }

  getAlertTypeTranslationCode(type: CustomerNotificationType): string {
    switch (type) {
      case CustomerNotificationType.BankNotificationPayNoc:
      case CustomerNotificationType.BankNotificationPayUndoNoc:
        return 'ALERTS.TYPE_NOTIFICATION_OF_CHANGE';
      case CustomerNotificationType.BankNotificationPayReturn:
      case CustomerNotificationType.BankNotificationPayUndoReturn:
        return 'ALERTS.TYPE_RETURN';
      case CustomerNotificationType.BankNotificationPayRejection:
      case CustomerNotificationType.BankNotificationPayUndoRejection:
        return 'ALERTS.TYPE_REJECTION';
      default:
        return 'ALERTS.TYPE_UNKNOWN';
    }
  }

  getPayStatusTranslationCode(type: CustomerNotificationType, amount: number): string {
    switch (type) {
      case CustomerNotificationType.BankNotificationPayNoc:
      case CustomerNotificationType.BankNotificationPayUndoNoc:
        return 'ALERTS.PAY_STATUS_AT_RISK';
      case CustomerNotificationType.BankNotificationPayReturn:
      case CustomerNotificationType.BankNotificationPayUndoReturn:
      case CustomerNotificationType.BankNotificationPayRejection:
      case CustomerNotificationType.BankNotificationPayUndoRejection:
        if (amount === 0) {
          return 'ALERTS.PAY_STATUS_AT_RISK';
        }
        return 'ALERTS.PAY_STATUS_NOT_PAID';
      default:
        return 'ALERTS.TYPE_UNKNOWN';
    }
  }

  getPayStatusDetailsTranslationCode(type: CustomerNotificationType, amount: number, isPrenote: boolean): string {
    switch (type) {
      case CustomerNotificationType.BankNotificationPayNoc:
      case CustomerNotificationType.BankNotificationPayUndoNoc:
        if (isPrenote) {
          return 'ALERTS.PAY_STATUS_AT_RISK_0_AMOUNT';
        }
        return 'ALERTS.PAY_STATUS_AT_RISK_NOC';
      case CustomerNotificationType.BankNotificationPayReturn:
      case CustomerNotificationType.BankNotificationPayUndoReturn:
      case CustomerNotificationType.BankNotificationPayRejection:
      case CustomerNotificationType.BankNotificationPayUndoRejection:
        if (amount === 0) {
          return 'ALERTS.PAY_STATUS_AT_RISK_0_AMOUNT';
        }
        return 'ALERTS.PAY_STATUS_NOT_PAID_DETAILS';
      default:
        return 'ALERTS.TYPE_UNKNOWN';
    }
  }

  getPayStatusIconClass(type: CustomerNotificationType, amount: number): string {
    switch (type) {
      case CustomerNotificationType.BankNotificationPayNoc:
      case CustomerNotificationType.BankNotificationPayUndoNoc:
        return 'pay_status_at_risk_icon';
      case CustomerNotificationType.BankNotificationPayReturn:
      case CustomerNotificationType.BankNotificationPayUndoReturn:
      case CustomerNotificationType.BankNotificationPayRejection:
      case CustomerNotificationType.BankNotificationPayUndoRejection:
        if (amount === 0) {
          return 'pay_status_at_risk_icon';
        }
        return 'pay_status_not_paid_icon';
      default:
        return '';
    }
  }

  getAccountTypeTranslationCode(accountType: EmployeeAlertDetailsAccountType): string {
    switch (accountType) {
      case EmployeeAlertDetailsAccountType.Checking:
        return 'ENUMS.EMPLOYEE_ALERT_DETAILS_ACCOUNT_TYPE.CHECKING';
      case EmployeeAlertDetailsAccountType.DebitCard:
        return 'ENUMS.EMPLOYEE_ALERT_DETAILS_ACCOUNT_TYPE.DEBIT_CARD';
      case EmployeeAlertDetailsAccountType.Savings:
        return 'ENUMS.EMPLOYEE_ALERT_DETAILS_ACCOUNT_TYPE.SAVINGS';
      case EmployeeAlertDetailsAccountType.Unknown:
      default:
        return '';
    }
  }

  areAnyNotifications(): boolean {
    return this.notificationGroups && this.notificationGroups.length > 0;
  }

  exportAlerts(): void {
    let obs: Observable<AlertNotificationDetails[]>;
    if (this.configService.isFeatureEnabled('enablePrenoteAlertsNotifications')) {
      obs = this.customerNotificationService.getNotificationDetailsForExport(this.settings.tenantId, this._getAlertIds());
    } else {
      obs = this.payService.getAlertsDetails(this._getAlertIds());
    }

    if (this.configService.isFeatureEnabled('eEPayPSGAlertUpdates')) {
      this.exportAlertsNewFormat(obs);
    } else {
      this.exportAlertsOldFormat(obs);
    }
  }

  exportAlertsOldFormat(obs: Observable<AlertNotificationDetails[]>): void {
    obs
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (details: ExportableAlertDetails[]) => {
          const items = details.map(x => new OldExportedAlertItem(
            x.companyName,
            x.payGroup,
            x.individualName,
            x.individualIdNumber,
            moment.parseZone(x.exceptionDate).format('MM/DD/YYYY'),
            moment.parseZone(x.payUtcDate).format('MM/DD/YYYY'),
            this.currencyPipe.transform(x.netAmount.toString(), '1.02', 'USD', true),
            x.accountNumber,
            x.routingNumber,
            this.enumPipe.transform(x.alertType, 'CustomerNotificationType'),
            x.bankCode,
            this.translateBankCode(x.bankCode),
            x.correctedData,
            x.companyIdentification,
            x.companyEntryDescription,
            x.dfiAccountNumber,
            x.originalEntryTraceNumber,
            x.effectiveEntryDate === this.minDate ? '' : moment(x.effectiveEntryDate).format('MM/DD/YYYY')
          ));
          this.fileExportService.exportAsCsvFile(items,
            'AlertsNotifications_' + this.settings.alias + '_' + moment().format('YYYYMMDDhhmmss'),
            OldExportedAlertItem.headers,
            OldExportedAlertItem.footer);
        },
        (error) => this._handleError(error));
  }

  exportAlertsNewFormat(obs: Observable<AlertNotificationDetails[]>): void {
    obs
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (details: ExportableAlertDetails[]) => {
          const items = details.map(x => new ExportedAlertItem(
            x.companyName,
            x.payGroup,
            x.individualName,
            this._stringify(x.individualIdNumber),
            moment.parseZone(x.exceptionDate).format('MM/DD/YYYY'),
            moment.parseZone(x.payUtcDate).format('MM/DD/YYYY'),
            this.currencyPipe.transform(x.netAmount.toString(), '1.02', 'USD', true),
            this._stringify(x.accountNumber),
            this._stringify(x.routingNumber),
            this.translateAccountType(x.accountType),
            this.enumPipe.transform(x.alertType, 'CustomerNotificationType'),
            x.bankCode,
            this.translateBankCode(x.bankCode),
            this._stringify(x.bankProvidedAccountNumber),
            this._stringify(x.bankProvidedRoutingNumber),
            this.translateAccountTypeAndCode(x.bankProvidedAccountType, x.bankProvidedAccountTypeCode),
            this._stringify(x.companyIdentification),
            x.companyEntryDescription,
            this._stringify(x.originalEntryTraceNumber),
            x.effectiveEntryDate === this.minDate ? '' : moment(x.effectiveEntryDate).format('MM/DD/YYYY')
          ));
          this.fileExportService.exportAsCsvFile(items,
            'AlertsNotifications_' + this.settings.alias + '_' + moment().format('YYYYMMDDhhmmss'),
            ExportedAlertItem.headers,
            ExportedAlertItem.footer);
        },
        (error) => this._handleError(error));
  }

  getEffectiveEntryDate(effectiveEntryDate: string): string {
    return effectiveEntryDate === this.minDate ? '' : effectiveEntryDate;
  }

  private _stringify(text: string): string {
    return (text) ? '"""' + text + '"""' : text;
  }

  private _getAlertIds(): string[] {

    if (!this.notificationGroups || this.notificationGroups.length === 0) {
      return new Array<string>();
    }
    const ids: string[] = [];

    this.notificationGroups.forEach(g => {
      ids.push(...g.notifications.map(n => n.id));
    });

    return ids;
  }

  /* Filter */
  private _initFilters(): void {
    this._initAllPayGroups();
    this._initAllPayrollTypes();
    this._initAllCompanies();
  }

  private _initAllPayGroups(): void {
    this.payGroupService.getPayGroups()
      .pipe(
        map(groups => sortBy(groups, ['code', 'name'])),
        takeUntil(this.destroy$)
      )
      .subscribe(
        result => this.allPayGroups = result,
        error => this._handleError(error)
      );
  }

  private _initAllPayrollTypes(): void {
    this.payrollTypeService.getPayrollTypes()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        result => this.allPayrollTypes = result,
        error => this._handleError(error)
      );
  }

  private _initAllCompanies(): void {
    this.companyService.getCompanyBasicInfos(this.settings.tenantId, 1, 500)
      .pipe(
        map(companies => sortBy(companies, ['legalName'])),
        takeUntil(this.destroy$)
      )
      .subscribe(
        result => {
          this.allCompanies = result;
        },
        error => this._handleError(error)
      );
  }

  get showAckDates(): boolean {
    return this.editFilters.hasAcknowledged;
  }

  onAckChange(): void {
    if (!this.editFilters.hasAcknowledged && !this.editFilters.ackFilter.isValid) {
      this.editFilters.ackFilter.resetDates();
    }
  }

  applyFilter(): void {
    this._clearStatusNotification();
    this._loadNotifications(this._selectedTab);
    this._refreshCount(this._selectedTab);
  }

  resetFilter(): void {
    this.editFilters = AlertsFilters.default;
    this.applyFilter();
  }

  get displayFromAfterToErrorMessage(): boolean {
    return this.editFilters.ackFilter.fromAckDateTime instanceof moment &&
    this.editFilters.ackFilter.toAckDateTime instanceof moment &&
    !this.editFilters.ackFilter.fromPrecedesTo;
  }

  typedMetadata(notif: CustomerNotification): BankNotificationPayMetadata {
    return notif.typedMetadata<BankNotificationPayMetadata>();
  }

  get payrollType(): PayrollCycleType {
    return this.editFilters.payrollType;
  }
  set payrollType(data: PayrollCycleType) {
    this.editFilters.payrollType = parseInt(data.toString(), 10);
  }

  acknowledgeButtonLabel(acknowledged: boolean): string {
    const token = acknowledged ? 'ALERTS.UNDO_ACKNOWLEDGE_BTN' : 'ALERTS.ACKNOWLEDGE_BTN';
    return this.translateService.instant(token);
  }
}
